import React from 'react';
import { Field, TextOutput } from '../../../../../../Core';
import { ListFieldSection } from '../../../../../../Layout';
import { withInjectedProps, NamePrefixModifier } from '../../../../../../Core/InjectedPropsContext';
import { useSelector } from 'react-redux';
import { getNumberOfSeparations, getSeparationPath, getSievingPortionLabelFromPath } from '../../../../Helpers';
import { pipe } from 'Lib/Hooks/Selectors';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';

let ResultsChecksSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const separationCount = useSelector(pipe(createWorksheetSelector!('', false), getNumberOfSeparations));
  const getPortionLabel = (path: string) => getSievingPortionLabelFromPath(path, separationCount);

  if (separationCount === 0) return null;

  return (
    <ListFieldSection heading="Checks">
      {Array(separationCount)
        .fill(undefined)
        .map((_, i) => (
          <React.Fragment key={i}>
            <NamePrefixModifier appendNamePrefix={`${getSeparationPath(i)}.CoarsePortion`}>
              <Field
                input={<TextOutput />}
                label={`${getPortionLabel(`${getSeparationPath(i)}.CoarsePortion`)} Loss (%)`}
                name="Sieving.PortionLoss"
              />
              {i > 0 && (
                <Field
                  input={<TextOutput />}
                  label={`Fractional Mass Retained on First Sieve of ${getPortionLabel(
                    `${getSeparationPath(i)}.CoarsePortion`
                  )} (%)`}
                  name="Sieving.FractionalPercentRetainedOnUpperLimitSieve"
                />
              )}
            </NamePrefixModifier>

            {i === separationCount - 1 && (
              <NamePrefixModifier appendNamePrefix={`${getSeparationPath(i)}.FinePortion.Subspecimen`}>
                <Field
                  input={<TextOutput />}
                  label={`Fractional Mass Retained on First Sieve of ${getPortionLabel(
                    `${getSeparationPath(i)}.FinePortion.Subspecimen`
                  )} (%)`}
                  name="Sieving.FractionalPercentRetainedOnUpperLimitSieve"
                />
              </NamePrefixModifier>
            )}
          </React.Fragment>
        ))}
    </ListFieldSection>
  );
};

ResultsChecksSection = withInjectedProps(ResultsChecksSection);

export { ResultsChecksSection };
export default ResultsChecksSection;
